/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Hotel',
  definitions: {
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.585 4.375h12.33a10.541 10.541 0 0 1 10.71 10.292v20.992H6.875V14.667a10.541 10.541 0 0 1 10.71-10.292zm-.016 1.25a9.29 9.29 0 0 0-9.444 9.064v19.72h31.25v-19.72a9.29 9.29 0 0 0-9.444-9.064H17.57zM16.4 17.727a2.774 2.774 0 0 0-2.82 2.701v8.28a2.773 2.773 0 0 0 2.82 2.701H31.1a2.774 2.774 0 0 0 2.82-2.7v-8.28a2.774 2.774 0 0 0-2.82-2.702H16.4zm2.84-1.25h-2.825a4.023 4.023 0 0 0-4.084 3.929V28.73a4.023 4.023 0 0 0 4.084 3.928h14.672a4.023 4.023 0 0 0 4.084-3.928v-8.325a4.023 4.023 0 0 0-4.084-3.929H28.26V14.6a2.325 2.325 0 0 0-2.357-2.27h-4.308a2.324 2.324 0 0 0-2.357 2.27v1.878zm7.772 0h-6.523v-1.855a1.074 1.074 0 0 1 1.092-1.043H25.92a1.074 1.074 0 0 1 1.092 1.043v1.855zM14.114 38.318c-1.349 0-2.398 1.044-2.398 2.279 0 1.234 1.05 2.278 2.398 2.278s2.397-1.044 2.397-2.279c0-1.234-1.05-2.278-2.397-2.278zm-3.648 2.279c0-1.973 1.657-3.529 3.648-3.529 1.99 0 3.647 1.556 3.647 3.529 0 1.972-1.657 3.528-3.647 3.528-1.991 0-3.648-1.556-3.648-3.529zm20.523 0c0-1.235 1.05-2.279 2.397-2.279 1.348 0 2.398 1.044 2.398 2.279 0 1.234-1.05 2.278-2.398 2.278s-2.398-1.044-2.398-2.279zm2.397-3.529c-1.99 0-3.648 1.556-3.648 3.529 0 1.972 1.658 3.528 3.648 3.528 1.99 0 3.648-1.556 3.648-3.529 0-1.972-1.657-3.528-3.648-3.528z"
            fill="#333"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
